import { message, notification, Modal } from "ant-design-vue";
/**
 * 封装的公用方法
 */
export default {
  /**
   * Message 屏幕中间 上方
   */
  /* type 默认 error 可选（success，error，warning，info）*/
  tipMessage: function(msg, type) {
    const newType = type || "error";
    return message[newType](msg);
  },
  /**
   * 右上角弹出提示
   */
  /* type 默认 error 可选（success，error，warning，info）*/
  tipNotification: function(message, type, title) {
    const newType = type || "error";
    return notification[newType]({
      message: title || "操作提示",
      description: message || "请求出现错误，请稍后再试",
    });
  },
  // 确定+取消 可操作的弹窗
  confirm: function(text, content) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: text,
        content: content,
        okText: "确认",
        okType: "danger",
        cancelText: "考虑一下",
        centered: true,
        onOk() {
          resolve();
        },
        onCancel() {
          reject();
        },
      });
    });
    // this.$confirm({
    //   title: "删除后不可恢复，确定删除？",
    //   content: 'Some descriptions',
    //   okText: '确认',
    //   okType: 'danger',
    //   cancelText: '考虑一下',
    //   centered: true,
    //   onOk() {
    //     console.log('OK');
    //   },
    //   onCancel() {
    //     console.log('Cancel');
    //     console.log(data);
    //   },
    // });
  },
  // 只有确定的 可操作的弹窗
  alert: function(content, text) {
    return new Promise(resolve => {
      Modal.info({
        title: text || "提示",
        content: content,
        okText: "确认",
        centered: true,
        onOk() {
          resolve();
        },
      });
    });
  },
};
